import React, { useState } from 'react';
import { Input, Button, message } from 'antd';
import {
  MailOutlined,
  PhoneOutlined,
  EditOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import './FloatingMessageBox.css';
import axiosInstance from './axiosInstance';
import { API } from '../API';

const FloatingMessageBox = () => {
  const [open, setOpen] = useState(false); // 控制弹窗是否打开
  const [email, setEmail] = useState(''); // 存储用户输入的邮箱
  const [tel, setTel] = useState(''); // 存储用户输入的电话
  const [detail, setDetail] = useState(''); // 存储用户输入的产品详情
  const [loading, setLoading] = useState(false); // 控制提交按钮的加载状态

  const handleSubmit = async () => {
    if (!email || !tel || !detail) {
      message.error('Please fill in all required fields.');
      return;
    }
    setLoading(true); // 设置加载状态为 true
    try {
      console.log('Sending message:', { email, tel, detail });
      await axiosInstance.post(`${API.ORDER}/order/subscriber`, {
        clientEmail: email,
        clientTel: tel,
        orderDetail: detail,
      }
    );
      message.success('Message sent successfully!');
      setOpen(false); // 关闭弹窗
      setEmail(''); // 清空邮箱输入框
      setTel(''); // 清空电话输入框
      setDetail(''); // 清空产品详情输入框
    } catch (error) {
      console.error('Error sending message:', error);
      message.error('Failed to send message. Please try again later.');
    } finally {
      setLoading(false); // 设置加载状态为 false
    }
  };

  return (
    <>
      {/* ✅ 显示按钮（当未打开弹窗时） */}
      {!open && (
        <div className="floating-button" onClick={() => setOpen(true)}>
          LEAVE A MESSAGE
        </div>
      )}

      {/* ✅ 显示弹窗（当打开时） */}
      {open && (
        <div className="floating-popup">
          <div className="popup-header">
            <span>Leave A Message</span>
            <CloseOutlined
              onClick={() => setOpen(false)}
              className="close-btn"
            />
          </div>

          <div className="popup-body">
            <p className="popup-description">
              If you are interested in our products and want to know more details,
              please leave a message here. We will reply to you as soon as we can.
            </p>

            <Input
              prefix={<MailOutlined />}
              placeholder="* Your Email :"
              value={email}
              onChange={(e) => setEmail(e.target.value)} 
              style={{ marginBottom: 10 }}
            />
            <Input
              prefix={<PhoneOutlined />}
              placeholder="Tel / WhatsApp :"
              value={tel}
              onChange={(e) => setTel(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <Input.TextArea
              rows={4}
              placeholder="* Enter product details (color, size, etc.)"
              value={detail}
              onChange={(e) => setDetail(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            <Button type="primary" block loading={loading} onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingMessageBox;